<template>
  <div>
    <v-tooltip v-for="locale in selectableLocales" :key="locale.key" bottom>
      <template v-slot:activator="{ on }">
        <base-btn text color="grey" v-on="on" @click="updateLocale(locale.key)">
          {{ locale.key }}
        </base-btn>
      </template>
      <span class="text-no-wrap">{{ locale.title }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  data() {
    return {
      locales: [
        { key: "en", title: "English" },
        { key: "et", title: "Eesti keeles" },
      ],
    };
  },
  computed: {
    selectableLocales() {
      return this.locales.filter((el) => el.key !== this.$i18n.locale);
    },
  },

  methods: {
    async updateLocale(key) {
      const response = await this.axios.post("language", { ...this.$route.query, locale: key });
      const data = response.data;
      const updatables = {};
      ["apartments", "buildings", "options"].forEach((key) => {
        if (_.has(data, key)) updatables[key] = data[key];
      });
      this.$store.commit("SET", updatables);
      this.$vuetify.lang.current = data.locale;
      this.$i18n.setLocaleMessage(data.locale, data.translations);
      this.$i18n.locale = data.locale;
      document.querySelector("html").setAttribute("lang", data.locale);
    },
  },
};
</script>
